import { getRelativeBasePath } from '../environments/path'
import { setSecurePageRedirect } from './url-redirector'

const HOME_PAGE_REDIRECTED_LIST = [
  '/',
  '/preview/login',
  '/preview/register',
  '/site/cti-advisor/login',
  '/site/cti-advisor/register/',
  '/login/',
  '/login',
  '/login/terms-conditions',
  '/login/terms-conditions/',
  '/register/',
  '/register',
  '/register/forgot-password',
  '/register/forgot-password/',
  '/dashboard/login-internal/',
  '/dashboard/login-internal',
  '/site/cti-advisor/dashboard/login-internal',
]

export function init() {
  const currentRelativeUrl = window.location.pathname + window.location.search

  // ok, who sent us here?
  let referrerPath = '/'
  try {
    const referrerUrl = new URL(document.referrer)
    referrerPath = referrerUrl.pathname
  } catch (error) {
    referrerPath = '/'
  }

  if (
    isAHomePageRedirectUrl(window.location.pathname) &&
    isAHomePageRedirectUrl(referrerPath)
  ) {
    if (!(window.location.pathname.indexOf('/dashboard/login-internal') >= 0)) {
      setSecurePageRedirect(getRelativeBasePath() + '/')
    }
  } else if (!isAHomePageRedirectUrl(window.location.pathname)) {
    setSecurePageRedirect(currentRelativeUrl)
  }
}

/**
 * If its on the list of pages that need to be redirected, the path match begins with the url, we redirect it to homepage on login
 */
const isAHomePageRedirectUrl = function (url) {
  return !!HOME_PAGE_REDIRECTED_LIST.find((item) => item === url)
}
